{
  "blocks": [
    {
      "id": "proc-two-week-wait",
      "kind": "procedure",
      "tags": ["ivf", "iui", "fet", "both-partners", "post-cycle", "emotional"],
      "title": "The Two-Week Wait",
      "subtitle": "The waiting period between embryo transfer (or IUI) and pregnancy test",
      "body": {
        "procedureName": "The Two-Week Wait",
        "category": "recovery",
        "description": "The waiting period between embryo transfer (or IUI) and pregnancy test. Typically 9-14 days.",
        "howItWorks": "After transfer or IUI, there's nothing medical to do except continue prescribed medications and wait for the beta hCG blood test. The embryo is implanting during this time, typically 1-5 days after a Day 5 transfer. Home pregnancy tests may show results starting 9-10 days post-transfer, but the official blood test is the definitive answer.",
        "duration": "9-14 days",
        "whatToExpect": [
          "Continue all prescribed medications exactly as directed",
          "Normal activities are fine, no need for bed rest",
          "Anxiety is completely normal",
          "Some spotting can occur and doesn't necessarily mean failure",
          "Avoid home pregnancy tests before day 9-10 if possible (high false negative rate earlier)",
          "Blood test (beta hCG) gives the definitive answer",
          "Symptom tracking can be useful, but symptoms are not reliable enough to predict the result"
        ],
        "results": [
          {
            "label": "Days 1-5",
            "detail": "The focus is recovery, medication consistency, hydration, and normal light activity. Symptoms during this window are often from progesterone, stimulation, retrieval, or the procedure itself."
          },
          {
            "label": "Days 6-10",
            "detail": "This is often the hardest stretch emotionally. Implantation may be underway after a blastocyst transfer, but symptoms and home tests can still be misleading."
          },
          {
            "label": "Days 11-14",
            "detail": "Testing becomes more informative, but the clinic beta hCG remains the result to anchor on. Follow your clinic's exact test date."
          },
          {
            "label": "Official result",
            "detail": "The beta hCG blood test is the clinic result. It is usually scheduled 9-14 days after transfer or IUI, depending on your protocol."
          },
          {
            "label": "If positive",
            "detail": "Many clinics repeat beta hCG about 48 hours later to see whether the level is rising appropriately."
          },
          {
            "label": "If negative",
            "detail": "Your clinic will tell you when to stop medications and will usually offer a follow-up to review what happened and next steps."
          }
        ],
        "risks": [
          "Anxiety and emotional stress",
          "Symptom-spotting (reading into every sensation)",
          "Premature testing leading to confusion",
          "Stopping progesterone or other medications before the clinic tells you to"
        ],
        "forWhom": "both",
        "frBody": {
          "procedureName": "Attente de deux semaines",
          "description": "Période d'attente entre le transfert d'embryon (ou l'IIU, insémination intra-utérine) et le test de grossesse. Habituellement 9 à 14 jours.",
          "howItWorks": "Après le transfert ou l'IIU, il n'y a rien d'autre à faire sur le plan médical que poursuivre les traitements prescrits et attendre le dosage de bêta-hCG. L'embryon s'implante pendant cette période, généralement 1 à 5 jours après un transfert J5. Les tests urinaires peuvent se positiver à partir du 9e–10e jour après le transfert, mais c'est le dosage sanguin qui donne la réponse définitive.",
          "duration": "9 à 14 jours",
          "whatToExpect": [
            "Poursuivez tous les traitements prescrits exactement comme indiqué",
            "Vos activités normales sont possibles, pas besoin de repos au lit",
            "L'anxiété est tout à fait normale",
            "Un léger spotting peut survenir et ne signifie pas forcément un échec",
            "Évitez si possible les tests urinaires avant J9–J10 (taux élevé de faux négatifs avant)",
            "Le dosage sanguin (bêta-hCG) apporte la réponse définitive",
            "Le suivi des symptômes peut aider, mais les symptômes ne permettent pas de prédire le résultat de façon fiable"
          ],
          "results": [
            {
              "label": "Jours 1 à 5",
              "detail": "L'objectif est la récupération, la régularité des traitements, l'hydratation et une activité légère normale. Les symptômes de cette période viennent souvent de la progestérone, de la stimulation, de la ponction ou du geste lui-même."
            },
            {
              "label": "Jours 6 à 10",
              "detail": "C'est souvent la période la plus difficile émotionnellement. L'implantation peut être en cours après un transfert de blastocyste, mais les symptômes et les tests urinaires peuvent encore être trompeurs."
            },
            {
              "label": "Jours 11 à 14",
              "detail": "Les tests deviennent plus informatifs, mais la bêta-hCG du centre reste le résultat de référence. Suivez la date exacte donnée par votre centre."
            },
            {
              "label": "Résultat officiel",
              "detail": "Le dosage sanguin de bêta-hCG est le résultat de référence du centre. Il est généralement prévu 9 à 14 jours après transfert ou IIU, selon votre protocole."
            },
            {
              "label": "Si positif",
              "detail": "Beaucoup de centres répètent la bêta-hCG environ 48 heures plus tard pour vérifier que le taux augmente correctement."
            },
            {
              "label": "Si négatif",
              "detail": "Votre centre vous dira quand arrêter les traitements et propose généralement un suivi pour revoir le cycle et les prochaines étapes."
            }
          ],
          "risks": [
            "Anxiété et stress émotionnel",
            "Symptom-spotting (sur-interprétation de chaque sensation)",
            "Test trop précoce, source de confusion",
            "Arrêt de la progestérone ou d'autres traitements avant consigne du centre"
          ]
        }
      },
      "sources": [
        {
          "title": "Live Birth Rate Following Bed Rest Versus Early Mobilization After Embryo Transfer: A Systematic Review And Meta-Analysis",
          "authors": "Rodriguez-Purata J et al.",
          "journal": "JBRA Assisted Reproduction",
          "year": 2022,
          "url": "https://pubmed.ncbi.nlm.nih.gov/35621274/",
          "evidenceLevel": "meta-analysis"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
